import {Link} from "react-router-dom";
import InterfaceRoute from "../interface/InterfaceRoutes";

//navState = antall steg man har "completed", steg man ikke har kommet til 
//skal man ikke kunne navigere til direkte
const trimStegviser = (routes: InterfaceRoute[], navState: number, location: string) => {
  return routes.map((r: InterfaceRoute, i) => {
    const renderAsSpan = i > navState
      return (
        {
          name: r.name,
          href: renderAsSpan ? "" : r.href,
          active: r.href ? location.indexOf(r.href) > -1 : false,
          asElement: renderAsSpan ? "span" : Link,
          hrefAttribute: "to"
        }
      )
    }
  )
}


export default trimStegviser;